import { FC } from 'react';

interface IconXProps {
  className?: string;
  fill?: boolean;
  duotone?: boolean;
}

const IconX: FC<IconXProps> = ({ className, fill = false, duotone = true }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};

export default IconX;
